import type { Hex } from 'viem';

import config from './config.json';

interface Config {
  bankAddress: string | null;
  relayAddress: string | null;
  erc721Address: string | null;
  migratorAddress: string | null;
  bankDepositAddress: string | null;
  ethMigrationPoolAddress: string | null;
  infuraEndpoint: string | null;
  evervault: {
    teamId: string;
    appId: string;
    ecdhP256Key: string;
    ecdhP256KeyUncompressed: string;
  };
  sorareEncryptionKey: string;
  vaultinumEncryptionKey: string;
  solanaRpcEndpoint: string | null;
}

// eslint-disable-next-line no-restricted-properties
const { hostname, search } = window.location;
const urlParams = new URLSearchParams(search);

export const ALLOWED_ORIGIN = urlParams.get('allowedOrigin');

const getEnvConfig = (): Config => {
  if (hostname.match(/sorare.(dev|tech)/)) {
    return config.staging;
  }
  if (hostname.match(/localhost/)) {
    const { port } = document.referrer
      ? new URL(document.referrer)
      : // eslint-disable-next-line no-restricted-properties
        window.location;
    switch (port) {
      case '3003':
        return config.production;
      case '4003':
      case '5003':
        return config.staging;
      default:
        return config.local;
    }
  }
  if (hostname.match(/sorare.netlify.app/)) {
    return config.preview;
  }

  return config.production;
};

const envConfig = getEnvConfig();

export const BANK_ADDRESS =
  envConfig.bankAddress || process.env.VITE_BANK_ADDRESS!;
export const RELAY_ADDRESS =
  envConfig.relayAddress || process.env.VITE_RELAY_ADDRESS!;
export const ERC721_ADDRESS =
  envConfig.erc721Address || process.env.VITE_ERC721_ADDRESS!;
export const MIGRATOR_ADDRESS = envConfig.migratorAddress! as Hex;
export const ETH_MIGRATION_POOL_ADDRESS = envConfig.ethMigrationPoolAddress!;
export const BANK_DEPOSIT_ADDRESS = envConfig.bankDepositAddress!;
export const INFURA_ENDPOINT =
  envConfig.infuraEndpoint || process.env.INFURA_ENDPOINT!;
export const EVERVAULT_CONFIG = envConfig.evervault;
export const ENCRYPTION_KEYS = {
  sorare: envConfig.sorareEncryptionKey,
  vaultinum: envConfig.vaultinumEncryptionKey,
};
export const SOLANA_RPC_ENDPOINT =
  envConfig.solanaRpcEndpoint || process.env.SOLANA_RPC_ENDPOINT!;
